import {Dialog} from "primereact/dialog";
import React, {useEffect, useState} from "react";
import {Button} from "primereact/button";
import { useTranslation } from "react-i18next";
import {Dropdown} from "primereact/dropdown";
import ProjectService from "./ProjectService";
import { RadioButton } from "primereact/radiobutton";
import {InputText} from "primereact/inputtext";
import {useParams} from "react-router-dom";

type DeviceAssignProps = {
    modal: boolean;
    deviceId: string;
    hidePopup: () => void;
    onSuccess: ()=> void;
}
const DeviceAssign = (props: DeviceAssignProps)=>{
    const { t } = useTranslation();
    const { projectId } = useParams<any>();

    const [projects, setProjects] = useState<any>([]);
    const [projectVals, setProjectVals] = useState<any>([]);
    const [projectSetting, setProjectSetting] = useState<string>('Yes');
    const [errors, setErrors] = useState<any>([]);
    const [stationName, setStationName] = useState<string>("");
    const projectService = new ProjectService();

    const validate = ()=>{
        let error: any = {};
        if(projects.length === 0){
            error["project"] = t("project_select");
            setErrors(error);
        }
        if(stationName === ""){
            error["station"] = t("station_name_empty");
            setErrors(error);
        }
        if (Object.keys(error).length !== 0) {
            return false;
        }

        return true;
    }
    const renderFooter = () => {
        return (
            <div>
                <Button
                    label={t("cancel")}
                    icon="pi pi-times"
                    onClick={() => props.hidePopup()}
                    className="p-button-text"
                />
                <Button
                    className="create-plant"
                    label={t("assign")}
                    icon="pi pi-check"
                    onClick={() => {
                        setErrors([]);
                        if(validate()){
                            const body = {
                                userId: localStorage.getItem('userId'),
                                projectSetting: projectSetting,
                                projectId: projects,
                                did: props.deviceId,
                                stationName: stationName
                            }
                            projectService.assignProject(body).then((response)=>{
                                if(response['error'] === 'Station name already exists'){
                                    let error: any = {};
                                    error["station"] = t("station_name_exist");
                                    setErrors(error);
                                }
                                if(response.status === 200){
                                    props.hidePopup();
                                    props.onSuccess();
                                }
                            })
                        }
                    }}
                    autoFocus
                />
            </div>
        );
    };

    useEffect(()=>{
        projectService.getAssignedDevices(localStorage.getItem('userId'), "").then((response) => {
            let dataArr : any = []
            response.map((val: any) => {
                const json = {
                    name: val['project']['project_name'],
                    value: val['project']['id']
                }
                dataArr.push(json);
            })
            setProjectVals(dataArr)
        });
        if(projectId !== undefined){
            setProjects(projectId)
        }
    },[])
    return(<>
        <Dialog
            header={t("assign_devices")}
            visible={props.modal}
            style={{ width: "30vw" }}
            footer={renderFooter()}
            onHide={() => props.hidePopup()}
        >
            <div className="grid align-items-center">
                <div className="col-12 lg:col-4">
                    <h5 className="">{t("select_project")}:</h5>
                </div>
                <div className="col-12 lg:col-8" >
                    <Dropdown
                        className="p-inputtext-sm"
                        value={projects}
                        options={projectVals}
                        onChange={(e) => { setProjects(e.value) }}
                        optionLabel="name"
                        placeholder={t("select_project")}
                    />
                </div>
            </div>
            <div className="grid align-items-center" >
                <div className="col-12 lg:col-4">
                    <h5 className="">{t("station_name")}:</h5>
                </div>
                <div className="col-12 lg:col-8">
                    <InputText
                        className="p-inputtext-sm"
                        value={stationName}
                        onChange={(e) => { setStationName(e.target.value) }}
                    />
                </div>
            </div>

            <div className="grid align-items-center">
                <div className="col-12 lg:col-6">
                    <h5 className="">{t("assign_project_setting")}:</h5>
                </div>
                <div className="col-12 lg:col-6">
                    <RadioButton inputId="yes" value="Yes" onChange={(e) => setProjectSetting(e.value)} checked={projectSetting === 'Yes'} />
                    <label htmlFor="yes" className="ml-2">{t('yes')}</label>

                    <RadioButton inputId="no" value="No" onChange={(e) => setProjectSetting(e.value)} checked={projectSetting === 'No'} style={{marginLeft: '10px'}}/>
                    <label htmlFor="no" className="ml-2">{t('no')}</label>
                </div>
            </div>

            <p className="error-message">{errors['project']}</p>
            <p className="error-message">{errors['station']}</p>


        </Dialog>
    </>)

}

export default DeviceAssign;